import React from 'react';
import Box from "../Box/Box";
import PropTypes from 'prop-types';
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import {Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import UserService from "../../services/UserService";
import CompanySelector from "../Company/CompanySelector";
import FormButtons from "../Form/FormButtons";
import CompanyService from "../../services/CompanyService";

class UserForm extends React.Component {

  userService = new UserService();
  companyService = new CompanyService();

  constructor(props) {
    super(props);
    const showCompany = UserService.hasRoles([UserService.ROLE_SUPER]);
    this.state = {showCompany};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;

    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.userService.findById(id).then(
          data => {
            this.companyService.findById(data.company.id).then(company => {
              data.company = company;
              this.setState({loading: false, entity: data});
            }, (error) => {
              if (error.response.status === 404) {
                state.message = 'Empresa não encontrada!';
              } else {
                state.message = 'Erro inesperado!';
                Notify.error('Falha o buscar entidade!', error)
              }
              this.setState(state);
            });
          },
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const {entity, showCompany} = this.state;
    const existingEntity = entity && entity.id;
    const company = showCompany ? {id: this.companyId} : null;

    let password = '';

    if (!existingEntity) {
      password = this.password.value;
      if (password !== this.retryPassword.value) {
        Notify.warning('Senhas não conferem');
        return;
      }
    }

    const entityToSave = {
      id: existingEntity,
      name: this.name.value && this.name.value.trim(),
      email: this.email.value.trim(),
      erpCode: this.erpCode.value,
      tagId: this.tagId.value,
      company,
      password,
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.userService.save(entityToSave).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => {
          if (error.response.status === 400) {
            Notify.warning("Email em uso");
            this.setState({
              loading: false,
              entity: entityToSave,
              message: null,
              BB: true
            });
            return;
          }
          Notify.error('Falha ao salvar entidade:', error);
          this.setState({loading: false, entity, message: null});
        }
    );
  }

  render() {
    const {loading, entity, message, showCompany} = this.state;
    const isNew = !(entity && entity.id);

    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }
    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control"
                     placeholder="Nome completo" required
                     name="first" ref={value => this.name = value}
                     defaultValue={entity && entity.name}
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>E-mail</ControlLabel>
              <input type="email" className="form-control"
                     placeholder="E-mail também utilizado para login" required
                     name="email" ref={email => this.email = email}
                     defaultValue={entity && entity.email}
              />
            </FormGroup>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Usuário(Código no ERP)</ControlLabel>
                  <input type="number" className="form-control"
                         placeholder="Nome do usuário, pode ser usada a matrícula no ERP"
                         name="erpCode" ref={erpCode => this.erpCode = erpCode}
                         defaultValue={entity && entity.erpCode}/>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <ControlLabel>TagID</ControlLabel>
                  <input type="text" className="form-control"
                         placeholder="Numero do cartão/cracha do funcionario (EPC)"
                         name="tagId" ref={tagId => this.tagId = tagId}
                         defaultValue={entity && entity.tagId}/>
                </FormGroup>
              </Col>
            </Row>

            {showCompany ?
                <CompanySelector
                    readonly={(entity && entity.company.id ? true : false)}
                    setValue={companyId => this.companyId = companyId}
                    defaultValue={entity && entity.company.id}/> : ''
            }

            {isNew ?
                <Row>
                  <Col sm={6} xs={6}>
                    <FormGroup>
                      <ControlLabel>Senha</ControlLabel>
                      <input type="password" className="form-control"
                             placeholder="Senha"
                             name="password"
                             ref={value => this.password = value}
                             defaultValue={entity && entity.password}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={6} xs={6}>
                    <FormGroup>
                      <ControlLabel>Confirmação de Senha</ControlLabel>
                      <input type="password" className="form-control"
                             placeholder="Repita a senha"
                             name="retryPassword"
                             ref={email => this.retryPassword = email}
                             defaultValue={entity && entity.retryPassword}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                : ''}

            <FormButtons history={this.props.history}/>
          </form>
        </Box>);
  }
}

UserForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/component/User/UserForm.js